/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import i18n from "../../plugins/locale/i18n";
import loadDictionary from "../../plugins/locale/load-dictionary";
import BankAccountService from "../../service/bank-account-service";
import PolicyService from "../../service/policy-service";
import RoleService from "../../service/role-service";

const bankAccountService = new BankAccountService();
const policyService = new PolicyService();
const roleService = new RoleService();

await loadDictionary('role-policies-window');

function RolePoliciesWindow({isOpenWindow, onCloseWindow, roleId}) {
  const [role, setRole] = useState(null);
  const [bankAccounts, setBankAccounts] = useState([]);
  const [accessibleAccounts, setAccessibleAccounts] = useState([]);

  const handleClose = () => {
    setRole(null);
    setBankAccounts([]);
    setAccessibleAccounts([]);

    onCloseWindow(false);
  };
  
  const handleSubmit = () => {
    const transactionRules = {
      accessible_accounts: accessibleAccounts
    };

    policyService.saveTransactionRulesByRoleId(role.id, transactionRules).then(() => {
      handleClose();
    }).catch(error => {
      console.error(error);
    });
  };

  const updateTransactionRules = (bankAccount) => {
    const hasRule = accessibleAccounts.some((bankAccountId) => bankAccountId == bankAccount.id);

    if(hasRule) {
      setAccessibleAccounts(accessibleAccounts.filter(bankAccountId => bankAccountId !== bankAccount.id));
    } else {
      const accessibleAccount = bankAccount.id; 

      setAccessibleAccounts([...accessibleAccounts, accessibleAccount]);
    }
  };

  useEffect(() => {
    if(!isOpenWindow || !roleId) return;

    Promise.all([roleService.findOne(roleId), bankAccountService.findAllByCompany(), policyService.findAllTransactionRulesByRoleId(roleId)])
      .then(([role, bankAccounts, rules]) => {
        setRole(role);
        setBankAccounts(bankAccounts);
        setAccessibleAccounts(rules.accessible_accounts);
      });
  }, [isOpenWindow, roleId]);

  const bankAccountItems = bankAccounts.map((bankAccount) => {
      const isChecked = accessibleAccounts.some((bankAccountId) => bankAccountId == bankAccount.id);

      return (
        <Form.Group className="mb-1 col-12" controlId="" key={bankAccount.id}>
          <Form.Check type="checkbox" value={bankAccount.id} checked={isChecked} onChange={() => {updateTransactionRules(bankAccount)}} label={bankAccount.name}/>
        </Form.Group>
      );
  });

  return (
    <Form method="POST" id="TransactionRuleForm" onSubmit={e => {e.preventDefault(); handleSubmit()}}>
    <Modal show={isOpenWindow} onHide={handleClose} backdrop="static" keyboard={false} scrollable={true}>
      <Modal.Header closeButton>
        <Modal.Title>{i18n.t("role-policies-window.title")}</Modal.Title>
      </Modal.Header>
      <div className="position-relative p-3 pb-1">
        <div className="row">
          <Form.Group className="mb-3 col" controlId="">
            <Form.Label>{i18n.t("role-policies-window.role_name")}</Form.Label>
            <Form.Control type="text" value={role?.name || ''} readOnly></Form.Control>
          </Form.Group>
        </div>
        <div className="row">
          <Form.Group className="col" controlId="">
            <Form.Label>{i18n.t("role-policies-window.section_list")}</Form.Label>
          </Form.Group>
        </div>
      </div>
      <Modal.Body className="pt-1">
        <div className="row">{bankAccountItems}</div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>{i18n.t("role-policies-window.cancel_button")}</Button>
        <Button variant="primary" type="submit" form="TransactionRuleForm" >{i18n.t("role-policies-window.create_button")}</Button>
      </Modal.Footer>
    </Modal>
    </Form>
  );
}

export default RolePoliciesWindow;